var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"timer",class:{
		'timer--fulltime': !_setup.isLive,
	}},[(_setup.isLive)?_c('div',{staticClass:"timer__circle"}):_vm._e(),_c('p',{staticClass:"timer__min",class:{ 'timer__min--live': _setup.isLive }},[_vm._t("default",function(){return [_vm._v(" "+_vm._s(_setup.gameStatusContent)+" ")]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }